import React from 'react';
import { Modal } from '@mui/material';
import SummaryComponents from './summaryComponent';

const SummaryModal = props => {
  const {
    open,
    handleClose,
    contactus,
    dataItems,
    lang,
    sessionDataItems,
    displayPartNumber,
    orderSummarySteps,
    uniquePartIdentifier
  } = props;

  return (
    <Modal open={open} onClose={handleClose} className="scrollable">
      <div>
        <SummaryComponents
          isModal={true}
          handleClose={handleClose}
          contactus={contactus}
          dataItems={dataItems}
          sessionDataItems={sessionDataItems}
          lang={lang}
          displayPartNumber={displayPartNumber}
          orderSummarySteps={orderSummarySteps}
          uniquePartIdentifier={uniquePartIdentifier}
        />
      </div>
    </Modal>
  );
};
export default SummaryModal;
